import * as React from 'react'

export default () => {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.31802 5.81802L5.5 9L8.68198 5.81802" stroke="#001335" />
      <path d="M11 10L0 10" stroke="#001335" />
      <path d="M5.5 8.5L5.5 0" stroke="#001335" />
    </svg>
  )
}
